import type { ProductDiscountedPriceDto } from '@api/models';

/** All a tiered discount needs to know about a product: every product DTO fits. */
export interface DiscountedProduct {
  discountedPrices: ProductDiscountedPriceDto[];
  price: number;
}

/**
 * Which tier the product sells at right now, or `undefined` while it sells at its own price: the
 * highest breakpoint the cart has already reached, or the highest one a single item covers by
 * itself.
 */
export const resolveActivePriceIndex = (
  product: DiscountedProduct | undefined,
  cartItemsCost: number | undefined,
): number | undefined => {
  if (!product?.discountedPrices) { return undefined; }

  for (let i = product.discountedPrices.length - 1; i >= 0; i--) {
    const costBreakpoint = product.discountedPrices[i].costBreakpoint;

    if ((cartItemsCost ?? 0) >= costBreakpoint || product.price >= costBreakpoint) { return i; }
  }

  return undefined;
};
